<!-- @format -->

<ng-container *transloco="let t">
  <div class="app-student-attainments">
    <fudis-section [title]="t('PROFILE.ATTAINMENTS')" [classes]="'fudis-mt-lg'" [level]="2">
      <fudis-section-actions>
        @if (transcriptPrintingEnabledByUniversity$ | async) {
          <fudis-button
            [label]="t('PROFILE.ATTAINMENT.BTN_PRINT')"
            [variant]="'secondary'"
            [size]="'small'"
            (handleClick)="printAttainments()" />
        }
      </fudis-section-actions>
      <fudis-section-content>
        <div class="col-12 col-md-5 col-lg-3">
          <label class="form-label">{{ t("PROFILE.ATTAINMENT.ATTAINMENT_STATE") }}</label>
          <sis-dropdown-select
            [options]="attainmentOptions$ | async"
            [selection]="selectedDisplay"
            (selectionChange)="onDropdownSelectionChange($event)">
          </sis-dropdown-select>
        </div>
        @if (selectedAttainmentNodes$ | async; as attainmentNodes) {
          <fudis-section
            [title]="t('PROFILE.ATTAINMENT.COMPILED_' + selectedDisplay)"
            [classes]="'fudis-mt-lg'"
            [level]="3"
            data-cy="student-attainments-compiled-section">
            <fudis-section-content>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.DEGREE_PROGRAMMES')"
                [classes]="'fudis-mt-md'"
                [titleVariant]="'md'"
                [level]="4"
                data-cy="student-attainments-degree-programmes-section">
                <fudis-section-content>
                  @if (attainmentNodes.degreeProgrammeAttainmentNodes.length > 0) {
                    @for (degreeProgrammeNode of attainmentNodes.degreeProgrammeAttainmentNodes; track degreeProgrammeNode) {
                      <app-student-attainment-node-wrapper [attainmentNode]="degreeProgrammeNode" [expandableLevel]="5" />
                    }
                  } @else {
                    <fudis-body-text>{{ t("PROFILE.ATTAINMENT.EMPTY") }}</fudis-body-text>
                  }
                </fudis-section-content>
              </fudis-section>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.MODULES')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-modules-section">
                <fudis-section-content>
                  @if (attainmentNodes.moduleAttainmentNodes.length > 0) {
                    @for (moduleAttainmentNode of attainmentNodes.moduleAttainmentNodes; track moduleAttainmentNode) {
                      <app-student-attainment-node-wrapper [attainmentNode]="moduleAttainmentNode" [expandableLevel]="5" />
                    }
                  } @else {
                    <fudis-body-text>{{ t("PROFILE.ATTAINMENT.EMPTY") }}</fudis-body-text>
                  }
                </fudis-section-content>
              </fudis-section>
            </fudis-section-content>
          </fudis-section>
          <fudis-section
            [title]="t('PROFILE.ATTAINMENT.UNATTACHED_' + selectedDisplay)"
            [classes]="'fudis-mt-lg'"
            [level]="3"
            data-cy="student-attainments-unattached-section">
            <fudis-section-content>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.COURSE_UNITS')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-course-units-section">
                <fudis-section-content>
                  @if (attainmentNodes.courseUnitAttainmentNodes.length > 0) {
                    @for (courseUnitAttainmentNode of attainmentNodes.courseUnitAttainmentNodes; track courseUnitAttainmentNode) {
                      <app-student-attainment-node-wrapper [attainmentNode]="courseUnitAttainmentNode" [expandableLevel]="5" />
                    }
                  } @else {
                    <fudis-body-text>{{ t("PROFILE.ATTAINMENT.EMPTY") }}</fudis-body-text>
                  }
                </fudis-section-content>
              </fudis-section>
              <fudis-section
                [title]="t('PROFILE.ATTAINMENT.ASSESSMENT_ITEMS')"
                [classes]="'fudis-mt-md'"
                [level]="4"
                data-cy="student-attainments-assessment-items-section">
                <fudis-section-content>
                  @if (attainmentNodes.assessmentItemAttainmentNodes.length > 0) {
                    @for (
                      assessmentItemAttainmentNode of attainmentNodes.assessmentItemAttainmentNodes;
                      track assessmentItemAttainmentNode
                    ) {
                      <app-student-attainment-node-wrapper [attainmentNode]="assessmentItemAttainmentNode" [expandableLevel]="5" />
                    }
                  } @else {
                    <fudis-body-text>{{ t("PROFILE.ATTAINMENT.EMPTY") }}</fudis-body-text>
                  }
                </fudis-section-content>
              </fudis-section>
            </fudis-section-content>
          </fudis-section>
        } @else {
          <div aria-busy="true" class="d-flex justify-content-center">
            <sis-small-spinner />
          </div>
        }
      </fudis-section-content>
    </fudis-section>
  </div>
</ng-container>
